<label [htmlFor]="id" [ngClass]="{ pointer: pointer }">
	<span class="label-text"> <ng-content /> </span>
	@if (!required) {
		<span class="label-optional"> ({{ "labels.state.optional" | translate }}) </span>
	}
	@if (missing) {
		<ic-indicator class="missing" icon="fa fa-warning" [text]="missingText" [warning]="true" />
	}
	@if (help) {
		<ic-indicator class="help" [text]="help" />
	}
</label>
